import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-thunder-icon',
  templateUrl: './general-thunder.component.html'
})
export class GeneralThunderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
